_collow.components.Timeline = class Timeline extends _collow.components.Base {
  root;
  elements;
  params;
  userLogo;
  startGrid;
  endGrid;

  constructor(root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    this.initialSetup();
    // this.renderName(course[0].user_name);
  }

  initialSetup = () => {
    // get user id
    const searchParams = new URLSearchParams(window.location.search);
    this.userId = searchParams.get("id");

    // setup date-range picker
    // const picker = new easepick.create({
    //   element: this.elements.datepicker,
    //   css: [
    //     "https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css",
    //     "https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.1/dist/index.css",
    //   ],
    //   plugins: ["RangePlugin"],
    // });
    // picker.on("select", this.dateChangeHandler);

    // setup inital date

    const date = new Date();
    const daysMonth = this.daysInMonth(date.getYear(), date.getMonth());
    this.setNumbersLines(daysMonth);

    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(
      date.getFullYear(),
      date.getMonth(),
      daysMonth
    );
    this.getTimelineInfo(firstDayOfMonth);
    this.gridStart = firstDayOfMonth;
    this.gridEnd = lastDayOfMonth;

    this.listen(this.elements.monthPicker, "change", this.monthChangeHanlder);
  };

  // dateChangeHandler = ({ detail }) => {
  //   const { start, end } = detail;
  //   this.gridStart = start;
  //   this.gridEnd = end;
  //   this.getTimelineInfo(start, end);
  //   const days = this.getDays(start, end);
  //   this.setNumbersLines(days + 1);
  //   this.updateDaysHeader(start);
  // };

  monthChangeHanlder = ({ target }) => {
    const currentDate = new Date();
    const selectedDate = new Date(target.value);
    if (Math.sign(currentDate - selectedDate) == -1) {
      target.value = "";
      return;
    }
    const [year, month] = target.value.split("-");
    const endDate = new Date(year, month, 0);
    this.gridStart = selectedDate;
    this.gridEnd = endDate;
    this.getTimelineInfo(selectedDate, endDate);

    const daysMonth = this.daysInMonth(
      selectedDate.getYear(),
      selectedDate.getMonth()
    );
    this.setNumbersLines(daysMonth);
  };
  /**
   * makes the API call to get the timeline info with the sent parameters
   * @param {Date} start_date the date the search starts
   * @param {Array[string]} searchTags (Optional) 'frontend', 'backend' ...
   * @param {Array[string]} courseIdentifiers (Optional) the UI of the course e.g 'introductie-tot-data-science-met-python'
   * @param {Date} end_date (Optional) the date the search ends
   */
  getTimelineInfo = (
    start_date,
    end_date = new Date(),
    searchTags = [],
    courseIdentifiers = []
  ) => {
    const url = `${this.params.path}/user/timeline?user_id=${this.userId}`;

    const body = new FormData();
    body.append("start_date", start_date.toISOString().split("T")[0]);
    body.append("search_tags", searchTags);
    body.append("course_identifiers", courseIdentifiers);
    body.append("end_date", end_date.toISOString().split("T")[0]);

    fetching(url, "put", body)
      .then((data) => {
        console.log(data);

        this.renderName(data.username, data.profile_picture);
        this.renderCourses(data.timeline_info);
      })
      .catch((err) => console.log(err));
  };

  renderCourses = (courses) => {
    // clear container from all courses
    this.elements.container.querySelectorAll("li").forEach((el) => el.remove());

    courses.forEach((course, ind) => {
      const { days, startDay, dateStringStart, dateStringFinish } =
        this.courseDates(course);

      const template = this.elements.templateCourse.content.cloneNode(true);
      const li = template.querySelector("li");
      let end = startDay + days - this.gridStart.getDate() + 1;
      if (end > this.gridEnd.getDate()) {
        li.dataset.afterRange = "";
        end = this.gridEnd.getDate();
      }
      let start = startDay - this.gridStart.getDate() + 1;
      if (
        new Date(course.registered_date).getTime() < this.gridStart.getTime()
      ) {
        start = 1;
        li.dataset.beforeRange = "";
      }

      li.style.gridColumn = `${start} / ${end}`;
      li.dataset.courseFinished = course.completed;
      li.querySelector("[data-timeline-course]").textContent =
        course.course_name;
      li.querySelector("label").htmlFor = "company-timeline-popup-" + ind;
      li.querySelector("input").id = "company-timeline-popup-" + ind;
      // popup content
      const popup = li.querySelector(".company-timeline__popup");
      popup.querySelector("p").textContent = course.course_name;
      // add date to popup
      popup.querySelector("small").textContent = `${dateStringStart} ${
        course.completed ? "- " + dateStringFinish : ""
      }`;
      this.elements.container.appendChild(template);
    });
  };

  courseDates = (course) => {
    const startDate = new Date(course.registered_date);
    const finishedDate = course.completed
      ? new Date(course.completed_date)
      : new Date(course.last_activity_date);
    let days = this.getDays(startDate, finishedDate);
    if (Math.sign(days) == -1) days = 1;

    const startDay = startDate.getDate();

    const dateStringStart = startDate.toLocaleDateString();
    const dateStringFinish = finishedDate.toLocaleDateString();

    return { days, startDay, dateStringStart, dateStringFinish };
  };

  renderName = (username, image) => {
    this.elements.username.textContent = username;
    if (!this.userLogo) {
      this.userLogo = image;
      this.elements.userLogo.src = image;
    }
  };
  getDays = (startDate, finishedDate) => {
    const timeDiffrence = finishedDate.getTime() - startDate.getTime();
    const days = Math.round(timeDiffrence / (1000 * 3600 * 24));
    return days;
  };

  daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

  setNumbersLines = (amount = 1) => {
    this.elements.wrapper.dataset.timelineRange = amount + 1;
  };
  updateDaysHeader = (start) => {
    this.elements.header
      .querySelectorAll("p")
      .forEach((el, ind) => (el.textContent = ind + start.getDate()));
  };
};

// TODO check where the start date is. if it is before the start of the grid adjust the days variable.
// TODO change the max of the course length to 31.
